/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AccountLevel,
  AccountStatusReasonBody,
  AddWalletRequestBody,
  AdminDebitOrCreditLevelPointRequestBody,
  ApiError,
  AtlasHashResponse,
  BanOrUnbanUserFromAllCommunitiesBody,
  BanUserFromCommunityBody,
  BulkUserActionBody,
  BulkUserActionResponse,
  ChangePasswordBody,
  ChangeUserPasswordBody,
  CreateUserBody,
  CreateUsersEarningSessionClaimResponse,
  ElectronClientVersionResponse,
  FormError,
  GetAccountLevelTransactionsSort,
  GetBannedCommunitiesResponse,
  GetExistingUserResponse,
  GetLeaderboardNicknameResponse,
  GetLootboxRedemptionsResponse,
  GetLootboxRedemptionsSort,
  GetUserCommunityMembershipResponse,
  GetUserResponse,
  GetUserSessionsResponse,
  GetUsersCsvResponse,
  GetUsersResponse,
  GetUsersSort,
  ImportUserBody,
  ImportUserResponse,
  LoginBody,
  LoginType,
  NftMintTransaction,
  NftOwnershipInformation,
  RemoveWalletRequestBody,
  SelfReportUnderageBody,
  SelfReportUnderageResponse,
  SetDateOfBirthBody,
  SetDateOfBirthResponse,
  SortOrder,
  ToggleMarketingBlacklistResponse,
  Token,
  TopLeaderboardRanksResponse,
  UpdateClipsRecordingPreferenceBody,
  UpdateCookieConsentBody,
  UpdateNicknameBody,
  UpdateNotificationsBody,
  UpdateProfileBody,
  UpdateProfilePictureBody,
  UpdateUserTypeBody,
  UserLeaderboardRankResponse,
  UserType,
  UsernameAvailabilityResponse,
} from '../models/index';
import {
    AccountLevelFromJSON,
    AccountLevelToJSON,
    AccountStatusReasonBodyFromJSON,
    AccountStatusReasonBodyToJSON,
    AddWalletRequestBodyFromJSON,
    AddWalletRequestBodyToJSON,
    AdminDebitOrCreditLevelPointRequestBodyFromJSON,
    AdminDebitOrCreditLevelPointRequestBodyToJSON,
    ApiErrorFromJSON,
    ApiErrorToJSON,
    AtlasHashResponseFromJSON,
    AtlasHashResponseToJSON,
    BanOrUnbanUserFromAllCommunitiesBodyFromJSON,
    BanOrUnbanUserFromAllCommunitiesBodyToJSON,
    BanUserFromCommunityBodyFromJSON,
    BanUserFromCommunityBodyToJSON,
    BulkUserActionBodyFromJSON,
    BulkUserActionBodyToJSON,
    BulkUserActionResponseFromJSON,
    BulkUserActionResponseToJSON,
    ChangePasswordBodyFromJSON,
    ChangePasswordBodyToJSON,
    ChangeUserPasswordBodyFromJSON,
    ChangeUserPasswordBodyToJSON,
    CreateUserBodyFromJSON,
    CreateUserBodyToJSON,
    CreateUsersEarningSessionClaimResponseFromJSON,
    CreateUsersEarningSessionClaimResponseToJSON,
    ElectronClientVersionResponseFromJSON,
    ElectronClientVersionResponseToJSON,
    FormErrorFromJSON,
    FormErrorToJSON,
    GetAccountLevelTransactionsSortFromJSON,
    GetAccountLevelTransactionsSortToJSON,
    GetBannedCommunitiesResponseFromJSON,
    GetBannedCommunitiesResponseToJSON,
    GetExistingUserResponseFromJSON,
    GetExistingUserResponseToJSON,
    GetLeaderboardNicknameResponseFromJSON,
    GetLeaderboardNicknameResponseToJSON,
    GetLootboxRedemptionsResponseFromJSON,
    GetLootboxRedemptionsResponseToJSON,
    GetLootboxRedemptionsSortFromJSON,
    GetLootboxRedemptionsSortToJSON,
    GetUserCommunityMembershipResponseFromJSON,
    GetUserCommunityMembershipResponseToJSON,
    GetUserResponseFromJSON,
    GetUserResponseToJSON,
    GetUserSessionsResponseFromJSON,
    GetUserSessionsResponseToJSON,
    GetUsersCsvResponseFromJSON,
    GetUsersCsvResponseToJSON,
    GetUsersResponseFromJSON,
    GetUsersResponseToJSON,
    GetUsersSortFromJSON,
    GetUsersSortToJSON,
    ImportUserBodyFromJSON,
    ImportUserBodyToJSON,
    ImportUserResponseFromJSON,
    ImportUserResponseToJSON,
    LoginBodyFromJSON,
    LoginBodyToJSON,
    LoginTypeFromJSON,
    LoginTypeToJSON,
    NftMintTransactionFromJSON,
    NftMintTransactionToJSON,
    NftOwnershipInformationFromJSON,
    NftOwnershipInformationToJSON,
    RemoveWalletRequestBodyFromJSON,
    RemoveWalletRequestBodyToJSON,
    SelfReportUnderageBodyFromJSON,
    SelfReportUnderageBodyToJSON,
    SelfReportUnderageResponseFromJSON,
    SelfReportUnderageResponseToJSON,
    SetDateOfBirthBodyFromJSON,
    SetDateOfBirthBodyToJSON,
    SetDateOfBirthResponseFromJSON,
    SetDateOfBirthResponseToJSON,
    SortOrderFromJSON,
    SortOrderToJSON,
    ToggleMarketingBlacklistResponseFromJSON,
    ToggleMarketingBlacklistResponseToJSON,
    TokenFromJSON,
    TokenToJSON,
    TopLeaderboardRanksResponseFromJSON,
    TopLeaderboardRanksResponseToJSON,
    UpdateClipsRecordingPreferenceBodyFromJSON,
    UpdateClipsRecordingPreferenceBodyToJSON,
    UpdateCookieConsentBodyFromJSON,
    UpdateCookieConsentBodyToJSON,
    UpdateNicknameBodyFromJSON,
    UpdateNicknameBodyToJSON,
    UpdateNotificationsBodyFromJSON,
    UpdateNotificationsBodyToJSON,
    UpdateProfileBodyFromJSON,
    UpdateProfileBodyToJSON,
    UpdateProfilePictureBodyFromJSON,
    UpdateProfilePictureBodyToJSON,
    UpdateUserTypeBodyFromJSON,
    UpdateUserTypeBodyToJSON,
    UserLeaderboardRankResponseFromJSON,
    UserLeaderboardRankResponseToJSON,
    UserTypeFromJSON,
    UserTypeToJSON,
    UsernameAvailabilityResponseFromJSON,
    UsernameAvailabilityResponseToJSON,
} from '../models/index';

export interface CreateLoginTypeRequest {
    type: LoginType;
    loginBody?: LoginBody;
}

export interface CreateRegisterMerchantRequest {
    createUserBody?: CreateUserBody;
}

export interface CreateUserAddWalletRequest {
    addWalletRequestBody?: AddWalletRequestBody;
}

export interface CreateUsersAdminDebitOrCreditLevelPointsRequest {
    adminDebitOrCreditLevelPointRequestBody?: AdminDebitOrCreditLevelPointRequestBody;
}

export interface CreateUsersBanOrUnbanUserFromAllCommunitiesRequest {
    banOrUnbanUserFromAllCommunitiesBody?: BanOrUnbanUserFromAllCommunitiesBody;
}

export interface CreateUsersBanUserFromCommunityRequest {
    banUserFromCommunityBody?: BanUserFromCommunityBody;
}

export interface CreateUsersBulkActionRequest {
    bulkUserActionBody?: BulkUserActionBody;
}

export interface CreateUsersDateOfBirthRequest {
    setDateOfBirthBody?: SetDateOfBirthBody;
}

export interface CreateUsersImportRequest {
    importUserBody?: ImportUserBody;
}

export interface CreateUsersLeaderboardNicknameRequest {
    updateNicknameBody?: UpdateNicknameBody;
}

export interface CreateUsersSelfReportUnderageRequest {
    selfReportUnderageBody?: SelfReportUnderageBody;
}

export interface CreateUsersUnbanUserFromCommunityRequest {
    banUserFromCommunityBody?: BanUserFromCommunityBody;
}

export interface DeleteUserRemoveWalletRequest {
    removeWalletRequestBody?: RemoveWalletRequestBody;
}

export interface DeleteUsersIdRequest {
    id: string;
}

export interface GetUsersRequest {
    type?: Array<UserType>;
    ids?: Array<string>;
    search?: string;
    includeDeleted?: string;
    sort?: GetUsersSort;
    order?: SortOrder;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetUsersEmailExistsRequest {
    email: string;
}

export interface GetUsersGetBannedCommunitiesIdRequest {
    id: string;
}

export interface GetUsersIdRequest {
    id: string;
}

export interface GetUsersIdMembershipRequest {
    id: string;
}

export interface GetUsersIdSessionsRequest {
    id: string;
    tokenId?: string;
}

export interface GetUsersLevelIdRequest {
    id: string;
    sort?: GetAccountLevelTransactionsSort;
    order?: SortOrder;
}

export interface GetUsersLootboxRedemptionsIdRequest {
    id: string;
    sort?: GetLootboxRedemptionsSort;
    order?: SortOrder;
}

export interface GetUsersTopLeaderboardRanksRequest {
    limit?: number;
    offset?: number;
}

export interface GetUsersUsernameAvailabilityRequest {
    name: string;
}

export interface GetUsersUserslvlRequest {
    type?: Array<UserType>;
}

export interface UpdateUsersChangePasswordRequest {
    changePasswordBody?: ChangePasswordBody;
}

export interface UpdateUsersFavoriteBusinessRequest {
    businessId?: string;
    body?: object;
}

export interface UpdateUsersIdChangePasswordRequest {
    id: string;
    changeUserPasswordBody?: ChangeUserPasswordBody;
}

export interface UpdateUsersIdDisableRequest {
    id: string;
    accountStatusReasonBody: AccountStatusReasonBody;
}

export interface UpdateUsersIdEnableRequest {
    id: string;
    accountStatusReasonBody: AccountStatusReasonBody;
}

export interface UpdateUsersIdMarketingBlacklistRequest {
    id: string;
    body?: object;
}

export interface UpdateUsersIdRemoveUserFromCommunityRequest {
    id: string;
    body?: object;
}

export interface UpdateUsersIdTypeRequest {
    id: string;
    updateUserTypeBody?: UpdateUserTypeBody;
}

export interface UpdateUsersPreferencesClipsRecordingRequest {
    updateClipsRecordingPreferenceBody: UpdateClipsRecordingPreferenceBody;
}

export interface UpdateUsersPreferencesCookieConsentRequest {
    updateCookieConsentBody: UpdateCookieConsentBody;
}

export interface UpdateUsersUpdateDefaultPaymentRequest {
    defaultPaymentMethodId?: string;
    body?: object;
}

export interface UpdateUsersUpdateNotificationsRequest {
    updateNotificationsBody?: UpdateNotificationsBody;
}

export interface UpdateUsersUpdateProfileRequest {
    updateProfileBody?: UpdateProfileBody;
}

export interface UpdateUsersUpdateProfilePictureRequest {
    updateProfilePictureBody?: UpdateProfilePictureBody;
}

/**
 * UsersApi - interface
 * 
 * @export
 * @interface UsersApiInterface
 */
export interface UsersApiInterface {
    /**
     * Generate an auth token for the dummy account used for testing. Disabled in production.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    createLoginTestUserRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Token>>;

    /**
     * Generate an auth token for the dummy account used for testing. Disabled in production.
     */
    createLoginTestUser(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Token>;

    /**
     * Used to log in admins and merchants.
     * @param {LoginType} type 
     * @param {LoginBody} [loginBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    createLoginTypeRaw(requestParameters: CreateLoginTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Token>>;

    /**
     * Used to log in admins and merchants.
     */
    createLoginType(requestParameters: CreateLoginTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Token>;

    /**
     * Used to register a merchant user
     * @param {CreateUserBody} [createUserBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    createRegisterMerchantRaw(requestParameters: CreateRegisterMerchantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUserResponse>>;

    /**
     * Used to register a merchant user
     */
    createRegisterMerchant(requestParameters: CreateRegisterMerchantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUserResponse>;

    /**
     * takes in the signature from a wallet to verify the public key.
     * @param {AddWalletRequestBody} [addWalletRequestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    createUserAddWalletRaw(requestParameters: CreateUserAddWalletRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * takes in the signature from a wallet to verify the public key.
     */
    createUserAddWallet(requestParameters: CreateUserAddWalletRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Allows an admin to debit or credit an arbitrary amount of fuel.
     * @param {AdminDebitOrCreditLevelPointRequestBody} [adminDebitOrCreditLevelPointRequestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    createUsersAdminDebitOrCreditLevelPointsRaw(requestParameters: CreateUsersAdminDebitOrCreditLevelPointsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Allows an admin to debit or credit an arbitrary amount of fuel.
     */
    createUsersAdminDebitOrCreditLevelPoints(requestParameters: CreateUsersAdminDebitOrCreditLevelPointsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Bans or unbans a user from all communities
     * @param {BanOrUnbanUserFromAllCommunitiesBody} [banOrUnbanUserFromAllCommunitiesBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    createUsersBanOrUnbanUserFromAllCommunitiesRaw(requestParameters: CreateUsersBanOrUnbanUserFromAllCommunitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Bans or unbans a user from all communities
     */
    createUsersBanOrUnbanUserFromAllCommunities(requestParameters: CreateUsersBanOrUnbanUserFromAllCommunitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Bans a user from a community, they will be unable to join until unbanned.
     * @param {BanUserFromCommunityBody} [banUserFromCommunityBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    createUsersBanUserFromCommunityRaw(requestParameters: CreateUsersBanUserFromCommunityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Bans a user from a community, they will be unable to join until unbanned.
     */
    createUsersBanUserFromCommunity(requestParameters: CreateUsersBanUserFromCommunityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Apply a bulk admin action (disable / enable / blacklist / unblacklist / delete) to a set of users. Used to clean an audience before a marketing send.
     * @param {BulkUserActionBody} [bulkUserActionBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    createUsersBulkActionRaw(requestParameters: CreateUsersBulkActionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkUserActionResponse>>;

    /**
     * Apply a bulk admin action (disable / enable / blacklist / unblacklist / delete) to a set of users. Used to clean an audience before a marketing send.
     */
    createUsersBulkAction(requestParameters: CreateUsersBulkActionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BulkUserActionResponse>;

    /**
     * Record the requesting account\'s date of birth. Write-once — an account that already has one is refused, and correcting a stored date is a support action. Required before entering any competition that costs money, which is open to players 18 and over. Self-reported and stored as a record, not verification.
     * @param {SetDateOfBirthBody} [setDateOfBirthBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    createUsersDateOfBirthRaw(requestParameters: CreateUsersDateOfBirthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SetDateOfBirthResponse>>;

    /**
     * Record the requesting account\'s date of birth. Write-once — an account that already has one is refused, and correcting a stored date is a support action. Required before entering any competition that costs money, which is open to players 18 and over. Self-reported and stored as a record, not verification.
     */
    createUsersDateOfBirth(requestParameters: CreateUsersDateOfBirthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SetDateOfBirthResponse>;

    /**
     * Moves the one-device-at-a-time gameplay slot to the calling device. Used by the \"Play here instead\" action after the account signed in elsewhere.  Requires no re-authentication: the caller\'s token is already valid, it simply was not the slot holder. The device that previously held the slot stops logging gameplay and is notified. 
     * @summary Make this device the one that logs gameplay
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    createUsersEarningSessionClaimRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateUsersEarningSessionClaimResponse>>;

    /**
     * Moves the one-device-at-a-time gameplay slot to the calling device. Used by the \"Play here instead\" action after the account signed in elsewhere.  Requires no re-authentication: the caller\'s token is already valid, it simply was not the slot holder. The device that previously held the slot stops logging gameplay and is notified. 
     * Make this device the one that logs gameplay
     */
    createUsersEarningSessionClaim(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateUsersEarningSessionClaimResponse>;

    /**
     * Used to import new users
     * @param {ImportUserBody} [importUserBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    createUsersImportRaw(requestParameters: CreateUsersImportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImportUserResponse>>;

    /**
     * Used to import new users
     */
    createUsersImport(requestParameters: CreateUsersImportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImportUserResponse>;

    /**
     * Update the leaderboard nickname of the current user. Empty nicknames are allowed (the leaderboard renders Player{N} as the display fallback). Non-empty nicknames must be globally unique (case-insensitive) and cannot contain profanity.
     * @param {UpdateNicknameBody} [updateNicknameBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    createUsersLeaderboardNicknameRaw(requestParameters: CreateUsersLeaderboardNicknameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Update the leaderboard nickname of the current user. Empty nicknames are allowed (the leaderboard renders Player{N} as the display fallback). Non-empty nicknames must be globally unique (case-insensitive) and cannot contain profanity.
     */
    createUsersLeaderboardNickname(requestParameters: CreateUsersLeaderboardNicknameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Reset isEjectedFromCommunity for a user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    createUsersResetCommunityEjectionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Reset isEjectedFromCommunity for a user.
     */
    createUsersResetCommunityEjection(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * The player confirmed a date of birth under 18. Records the date and disables the account immediately with a stored reason. Refuses a date of 18 or over. The response carries the support contact, which is the appeal path.
     * @param {SelfReportUnderageBody} [selfReportUnderageBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    createUsersSelfReportUnderageRaw(requestParameters: CreateUsersSelfReportUnderageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SelfReportUnderageResponse>>;

    /**
     * The player confirmed a date of birth under 18. Records the date and disables the account immediately with a stored reason. Refuses a date of 18 or over. The response carries the support contact, which is the appeal path.
     */
    createUsersSelfReportUnderage(requestParameters: CreateUsersSelfReportUnderageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SelfReportUnderageResponse>;

    /**
     * Unbans a user from a community.
     * @param {BanUserFromCommunityBody} [banUserFromCommunityBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    createUsersUnbanUserFromCommunityRaw(requestParameters: CreateUsersUnbanUserFromCommunityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Unbans a user from a community.
     */
    createUsersUnbanUserFromCommunity(requestParameters: CreateUsersUnbanUserFromCommunityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * removes a wallet from the given account.
     * @param {RemoveWalletRequestBody} [removeWalletRequestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    deleteUserRemoveWalletRaw(requestParameters: DeleteUserRemoveWalletRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * removes a wallet from the given account.
     */
    deleteUserRemoveWallet(requestParameters: DeleteUserRemoveWalletRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Admin-initiated account deletion. Runs the same soft-delete + PII scrub cascade as user self-delete; the user document is retained (tombstoned) for churn data.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    deleteUsersIdRaw(requestParameters: DeleteUsersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Admin-initiated account deletion. Runs the same soft-delete + PII scrub cascade as user self-delete; the user document is retained (tombstoned) for churn data.
     */
    deleteUsersId(requestParameters: DeleteUsersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * get user\'s current level lootbox mint record
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    getUserLootboxMintRecordRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NftMintTransaction>>;

    /**
     * get user\'s current level lootbox mint record
     */
    getUserLootboxMintRecord(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NftMintTransaction>;

    /**
     * 
     * @param {Array<UserType>} [type] 
     * @param {Array<string>} [ids] 
     * @param {string} [search] 
     * @param {string} [includeDeleted] Pass \&quot;true\&quot; to include soft-deleted (churned) users; deleted users are hidden by default
     * @param {GetUsersSort} [sort] 
     * @param {SortOrder} [order] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    getUsersRaw(requestParameters: GetUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUsersResponse>>;

    /**
     */
    getUsers(requestParameters: GetUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUsersResponse>;

    /**
     * Get user authentication hash for Atlas chat session.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    getUsersAtlasHashRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AtlasHashResponse>>;

    /**
     * Get user authentication hash for Atlas chat session.
     */
    getUsersAtlasHash(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AtlasHashResponse>;

    /**
     * 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    getUsersEmailExistsRaw(requestParameters: GetUsersEmailExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetExistingUserResponse>>;

    /**
     */
    getUsersEmailExists(requestParameters: GetUsersEmailExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetExistingUserResponse>;

    /**
     * Get all communities a user is banned from
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    getUsersGetBannedCommunitiesIdRaw(requestParameters: GetUsersGetBannedCommunitiesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBannedCommunitiesResponse>>;

    /**
     * Get all communities a user is banned from
     */
    getUsersGetBannedCommunitiesId(requestParameters: GetUsersGetBannedCommunitiesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBannedCommunitiesResponse>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    getUsersIdRaw(requestParameters: GetUsersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUserResponse>>;

    /**
     */
    getUsersId(requestParameters: GetUsersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUserResponse>;

    /**
     * Get information regarding the user\'s community, their rank and points earned for the community.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    getUsersIdMembershipRaw(requestParameters: GetUsersIdMembershipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUserCommunityMembershipResponse>>;

    /**
     * Get information regarding the user\'s community, their rank and points earned for the community.
     */
    getUsersIdMembership(requestParameters: GetUsersIdMembershipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUserCommunityMembershipResponse>;

    /**
     * 
     * @param {string} id 
     * @param {string} [tokenId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    getUsersIdSessionsRaw(requestParameters: GetUsersIdSessionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUserSessionsResponse>>;

    /**
     */
    getUsersIdSessions(requestParameters: GetUsersIdSessionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUserSessionsResponse>;

    /**
     * Get the leaderboard nickname of the current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    getUsersLeaderboardNicknameRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLeaderboardNicknameResponse>>;

    /**
     * Get the leaderboard nickname of the current user.
     */
    getUsersLeaderboardNickname(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLeaderboardNicknameResponse>;

    /**
     * Get the leaderboard rank of the current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    getUsersLeaderboardRankRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserLeaderboardRankResponse>>;

    /**
     * Get the leaderboard rank of the current user.
     */
    getUsersLeaderboardRank(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserLeaderboardRankResponse>;

    /**
     * Get information regarding the user\'s level and experience.
     * @param {string} id 
     * @param {GetAccountLevelTransactionsSort} [sort] 
     * @param {SortOrder} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    getUsersLevelIdRaw(requestParameters: GetUsersLevelIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccountLevel>>;

    /**
     * Get information regarding the user\'s level and experience.
     */
    getUsersLevelId(requestParameters: GetUsersLevelIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccountLevel>;

    /**
     * Get lootbox redemption history for a user
     * @param {string} id 
     * @param {GetLootboxRedemptionsSort} [sort] 
     * @param {SortOrder} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    getUsersLootboxRedemptionsIdRaw(requestParameters: GetUsersLootboxRedemptionsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLootboxRedemptionsResponse>>;

    /**
     * Get lootbox redemption history for a user
     */
    getUsersLootboxRedemptionsId(requestParameters: GetUsersLootboxRedemptionsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLootboxRedemptionsResponse>;

    /**
     * Returns the SemVer version of the user\'s DevourPlay Electron client, captured server-side from the User-Agent header. Reads the durable `lastElectronVersion` stamped on the account at desktop login, falling back to the 60-minute Redis presence key when the account predates that stamp. Returns null for an account that has never signed in from the desktop app. Path is `/users/me/...` rather than `/users/electron-client-version` to avoid Express matching it against the wildcard `GET /users/:id` route in get_user.ts (which would CastError on the literal string).
     * @summary Get the version of the user\'s currently-running Electron client
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    getUsersMeElectronClientVersionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ElectronClientVersionResponse>>;

    /**
     * Returns the SemVer version of the user\'s DevourPlay Electron client, captured server-side from the User-Agent header. Reads the durable `lastElectronVersion` stamped on the account at desktop login, falling back to the 60-minute Redis presence key when the account predates that stamp. Returns null for an account that has never signed in from the desktop app. Path is `/users/me/...` rather than `/users/electron-client-version` to avoid Express matching it against the wildcard `GET /users/:id` route in get_user.ts (which would CastError on the literal string).
     * Get the version of the user\'s currently-running Electron client
     */
    getUsersMeElectronClientVersion(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ElectronClientVersionResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    getUsersNftOwnershipsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NftOwnershipInformation>>;

    /**
     */
    getUsersNftOwnerships(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NftOwnershipInformation>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    getUsersProfileRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUserResponse>>;

    /**
     */
    getUsersProfile(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUserResponse>;

    /**
     * Get top users ranked by total experience, with pagination.
     * @param {number} [limit] Number of users to return (default 50, max 100)
     * @param {number} [offset] Number of users to skip (default 0)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    getUsersTopLeaderboardRanksRaw(requestParameters: GetUsersTopLeaderboardRanksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TopLeaderboardRanksResponse>>;

    /**
     * Get top users ranked by total experience, with pagination.
     */
    getUsersTopLeaderboardRanks(requestParameters: GetUsersTopLeaderboardRanksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TopLeaderboardRanksResponse>;

    /**
     * Is this username free to register? Auth optional, so the signup form can ask before an account exists; signed in, a name held by the caller\'s own Drop counts as available.
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    getUsersUsernameAvailabilityRaw(requestParameters: GetUsersUsernameAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UsernameAvailabilityResponse>>;

    /**
     * Is this username free to register? Auth optional, so the signup form can ask before an account exists; signed in, a name held by the caller\'s own Drop counts as available.
     */
    getUsersUsernameAvailability(requestParameters: GetUsersUsernameAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UsernameAvailabilityResponse>;

    /**
     * 
     * @param {Array<UserType>} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    getUsersUserslvlRaw(requestParameters: GetUsersUserslvlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUsersCsvResponse>>;

    /**
     */
    getUsersUserslvl(requestParameters: GetUsersUserslvlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUsersCsvResponse>;

    /**
     * Used by users to change their passwords.
     * @param {ChangePasswordBody} [changePasswordBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    updateUsersChangePasswordRaw(requestParameters: UpdateUsersChangePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used by users to change their passwords.
     */
    updateUsersChangePassword(requestParameters: UpdateUsersChangePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used by users to add or remove a business from their favorites list.
     * @param {string} [businessId] 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    updateUsersFavoriteBusinessRaw(requestParameters: UpdateUsersFavoriteBusinessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used by users to add or remove a business from their favorites list.
     */
    updateUsersFavoriteBusiness(requestParameters: UpdateUsersFavoriteBusinessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used by GOD admins to change user\'s passwords.
     * @param {string} id 
     * @param {ChangeUserPasswordBody} [changeUserPasswordBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    updateUsersIdChangePasswordRaw(requestParameters: UpdateUsersIdChangePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used by GOD admins to change user\'s passwords.
     */
    updateUsersIdChangePassword(requestParameters: UpdateUsersIdChangePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used by admins to disable a user
     * @param {string} id 
     * @param {AccountStatusReasonBody} accountStatusReasonBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    updateUsersIdDisableRaw(requestParameters: UpdateUsersIdDisableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used by admins to disable a user
     */
    updateUsersIdDisable(requestParameters: UpdateUsersIdDisableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used by GOD admins to enable a user
     * @param {string} id 
     * @param {AccountStatusReasonBody} accountStatusReasonBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    updateUsersIdEnableRaw(requestParameters: UpdateUsersIdEnableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used by GOD admins to enable a user
     */
    updateUsersIdEnable(requestParameters: UpdateUsersIdEnableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Toggle marketing blacklist status for a user (admin only)
     * @param {string} id 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    updateUsersIdMarketingBlacklistRaw(requestParameters: UpdateUsersIdMarketingBlacklistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ToggleMarketingBlacklistResponse>>;

    /**
     * Toggle marketing blacklist status for a user (admin only)
     */
    updateUsersIdMarketingBlacklist(requestParameters: UpdateUsersIdMarketingBlacklistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ToggleMarketingBlacklistResponse>;

    /**
     * Removes a user from their current community
     * @param {string} id 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    updateUsersIdRemoveUserFromCommunityRaw(requestParameters: UpdateUsersIdRemoveUserFromCommunityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Removes a user from their current community
     */
    updateUsersIdRemoveUserFromCommunity(requestParameters: UpdateUsersIdRemoveUserFromCommunityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used by admins to change a user\'s type.
     * @param {string} id 
     * @param {UpdateUserTypeBody} [updateUserTypeBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    updateUsersIdTypeRaw(requestParameters: UpdateUsersIdTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used by admins to change a user\'s type.
     */
    updateUsersIdType(requestParameters: UpdateUsersIdTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Set the per-account clip recording toggle
     * @param {UpdateClipsRecordingPreferenceBody} updateClipsRecordingPreferenceBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    updateUsersPreferencesClipsRecordingRaw(requestParameters: UpdateUsersPreferencesClipsRecordingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Set the per-account clip recording toggle
     */
    updateUsersPreferencesClipsRecording(requestParameters: UpdateUsersPreferencesClipsRecordingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Persist the signed-in user\'s cookie-consent decision to their account
     * @param {UpdateCookieConsentBody} updateCookieConsentBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    updateUsersPreferencesCookieConsentRaw(requestParameters: UpdateUsersPreferencesCookieConsentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Persist the signed-in user\'s cookie-consent decision to their account
     */
    updateUsersPreferencesCookieConsent(requestParameters: UpdateUsersPreferencesCookieConsentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used by users to remove their profile picture.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    updateUsersRemoveProfilePictureRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used by users to remove their profile picture.
     */
    updateUsersRemoveProfilePicture(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used by users to add, remove or update their default payment method.
     * @param {string} [defaultPaymentMethodId] 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    updateUsersUpdateDefaultPaymentRaw(requestParameters: UpdateUsersUpdateDefaultPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used by users to add, remove or update their default payment method.
     */
    updateUsersUpdateDefaultPayment(requestParameters: UpdateUsersUpdateDefaultPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    updateUsersUpdateNftOwnershipsForUserRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    updateUsersUpdateNftOwnershipsForUser(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used by users to update their profile.
     * @param {UpdateNotificationsBody} [updateNotificationsBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    updateUsersUpdateNotificationsRaw(requestParameters: UpdateUsersUpdateNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used by users to update their profile.
     */
    updateUsersUpdateNotifications(requestParameters: UpdateUsersUpdateNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used by users to update their profile.
     * @param {UpdateProfileBody} [updateProfileBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    updateUsersUpdateProfileRaw(requestParameters: UpdateUsersUpdateProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used by users to update their profile.
     */
    updateUsersUpdateProfile(requestParameters: UpdateUsersUpdateProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used by users to update their profile picture.
     * @param {UpdateProfilePictureBody} [updateProfilePictureBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    updateUsersUpdateProfilePictureRaw(requestParameters: UpdateUsersUpdateProfilePictureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used by users to update their profile picture.
     */
    updateUsersUpdateProfilePicture(requestParameters: UpdateUsersUpdateProfilePictureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class UsersApi extends runtime.BaseAPI implements UsersApiInterface {

    /**
     * Generate an auth token for the dummy account used for testing. Disabled in production.
     */
    async createLoginTestUserRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Token>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/login-test-user`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TokenFromJSON(jsonValue));
    }

    /**
     * Generate an auth token for the dummy account used for testing. Disabled in production.
     */
    async createLoginTestUser(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Token> {
        const response = await this.createLoginTestUserRaw(initOverrides);
        return await response.value();
    }

    /**
     * Used to log in admins and merchants.
     */
    async createLoginTypeRaw(requestParameters: CreateLoginTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Token>> {
        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError(
                'type',
                'Required parameter "type" was null or undefined when calling createLoginType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/login/{type}`;
        urlPath = urlPath.replace(`{${"type"}}`, encodeURIComponent(String(requestParameters['type'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LoginBodyToJSON(requestParameters['loginBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TokenFromJSON(jsonValue));
    }

    /**
     * Used to log in admins and merchants.
     */
    async createLoginType(requestParameters: CreateLoginTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Token> {
        const response = await this.createLoginTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to register a merchant user
     */
    async createRegisterMerchantRaw(requestParameters: CreateRegisterMerchantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUserResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Discriminated", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/register/merchant`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUserBodyToJSON(requestParameters['createUserBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUserResponseFromJSON(jsonValue));
    }

    /**
     * Used to register a merchant user
     */
    async createRegisterMerchant(requestParameters: CreateRegisterMerchantRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUserResponse> {
        const response = await this.createRegisterMerchantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * takes in the signature from a wallet to verify the public key.
     */
    async createUserAddWalletRaw(requestParameters: CreateUserAddWalletRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("StandardUser", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user/add-wallet`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddWalletRequestBodyToJSON(requestParameters['addWalletRequestBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * takes in the signature from a wallet to verify the public key.
     */
    async createUserAddWallet(requestParameters: CreateUserAddWalletRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createUserAddWalletRaw(requestParameters, initOverrides);
    }

    /**
     * Allows an admin to debit or credit an arbitrary amount of fuel.
     */
    async createUsersAdminDebitOrCreditLevelPointsRaw(requestParameters: CreateUsersAdminDebitOrCreditLevelPointsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("GodAdmin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/admin-debit-or-credit-level-points`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminDebitOrCreditLevelPointRequestBodyToJSON(requestParameters['adminDebitOrCreditLevelPointRequestBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Allows an admin to debit or credit an arbitrary amount of fuel.
     */
    async createUsersAdminDebitOrCreditLevelPoints(requestParameters: CreateUsersAdminDebitOrCreditLevelPointsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createUsersAdminDebitOrCreditLevelPointsRaw(requestParameters, initOverrides);
    }

    /**
     * Bans or unbans a user from all communities
     */
    async createUsersBanOrUnbanUserFromAllCommunitiesRaw(requestParameters: CreateUsersBanOrUnbanUserFromAllCommunitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/ban-or-unban-user-from-all-communities`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BanOrUnbanUserFromAllCommunitiesBodyToJSON(requestParameters['banOrUnbanUserFromAllCommunitiesBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Bans or unbans a user from all communities
     */
    async createUsersBanOrUnbanUserFromAllCommunities(requestParameters: CreateUsersBanOrUnbanUserFromAllCommunitiesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createUsersBanOrUnbanUserFromAllCommunitiesRaw(requestParameters, initOverrides);
    }

    /**
     * Bans a user from a community, they will be unable to join until unbanned.
     */
    async createUsersBanUserFromCommunityRaw(requestParameters: CreateUsersBanUserFromCommunityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/ban-user-from-community`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BanUserFromCommunityBodyToJSON(requestParameters['banUserFromCommunityBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Bans a user from a community, they will be unable to join until unbanned.
     */
    async createUsersBanUserFromCommunity(requestParameters: CreateUsersBanUserFromCommunityRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createUsersBanUserFromCommunityRaw(requestParameters, initOverrides);
    }

    /**
     * Apply a bulk admin action (disable / enable / blacklist / unblacklist / delete) to a set of users. Used to clean an audience before a marketing send.
     */
    async createUsersBulkActionRaw(requestParameters: CreateUsersBulkActionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkUserActionResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/bulk-action`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BulkUserActionBodyToJSON(requestParameters['bulkUserActionBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkUserActionResponseFromJSON(jsonValue));
    }

    /**
     * Apply a bulk admin action (disable / enable / blacklist / unblacklist / delete) to a set of users. Used to clean an audience before a marketing send.
     */
    async createUsersBulkAction(requestParameters: CreateUsersBulkActionRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BulkUserActionResponse> {
        const response = await this.createUsersBulkActionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Record the requesting account\'s date of birth. Write-once — an account that already has one is refused, and correcting a stored date is a support action. Required before entering any competition that costs money, which is open to players 18 and over. Self-reported and stored as a record, not verification.
     */
    async createUsersDateOfBirthRaw(requestParameters: CreateUsersDateOfBirthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SetDateOfBirthResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/date-of-birth`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetDateOfBirthBodyToJSON(requestParameters['setDateOfBirthBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SetDateOfBirthResponseFromJSON(jsonValue));
    }

    /**
     * Record the requesting account\'s date of birth. Write-once — an account that already has one is refused, and correcting a stored date is a support action. Required before entering any competition that costs money, which is open to players 18 and over. Self-reported and stored as a record, not verification.
     */
    async createUsersDateOfBirth(requestParameters: CreateUsersDateOfBirthRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SetDateOfBirthResponse> {
        const response = await this.createUsersDateOfBirthRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Moves the one-device-at-a-time gameplay slot to the calling device. Used by the \"Play here instead\" action after the account signed in elsewhere.  Requires no re-authentication: the caller\'s token is already valid, it simply was not the slot holder. The device that previously held the slot stops logging gameplay and is notified. 
     * Make this device the one that logs gameplay
     */
    async createUsersEarningSessionClaimRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateUsersEarningSessionClaimResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/earning-session/claim`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateUsersEarningSessionClaimResponseFromJSON(jsonValue));
    }

    /**
     * Moves the one-device-at-a-time gameplay slot to the calling device. Used by the \"Play here instead\" action after the account signed in elsewhere.  Requires no re-authentication: the caller\'s token is already valid, it simply was not the slot holder. The device that previously held the slot stops logging gameplay and is notified. 
     * Make this device the one that logs gameplay
     */
    async createUsersEarningSessionClaim(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateUsersEarningSessionClaimResponse> {
        const response = await this.createUsersEarningSessionClaimRaw(initOverrides);
        return await response.value();
    }

    /**
     * Used to import new users
     */
    async createUsersImportRaw(requestParameters: CreateUsersImportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImportUserResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/import`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ImportUserBodyToJSON(requestParameters['importUserBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ImportUserResponseFromJSON(jsonValue));
    }

    /**
     * Used to import new users
     */
    async createUsersImport(requestParameters: CreateUsersImportRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImportUserResponse> {
        const response = await this.createUsersImportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update the leaderboard nickname of the current user. Empty nicknames are allowed (the leaderboard renders Player{N} as the display fallback). Non-empty nicknames must be globally unique (case-insensitive) and cannot contain profanity.
     */
    async createUsersLeaderboardNicknameRaw(requestParameters: CreateUsersLeaderboardNicknameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/leaderboard-nickname`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateNicknameBodyToJSON(requestParameters['updateNicknameBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update the leaderboard nickname of the current user. Empty nicknames are allowed (the leaderboard renders Player{N} as the display fallback). Non-empty nicknames must be globally unique (case-insensitive) and cannot contain profanity.
     */
    async createUsersLeaderboardNickname(requestParameters: CreateUsersLeaderboardNicknameRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createUsersLeaderboardNicknameRaw(requestParameters, initOverrides);
    }

    /**
     * Reset isEjectedFromCommunity for a user.
     */
    async createUsersResetCommunityEjectionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/reset-community-ejection`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Reset isEjectedFromCommunity for a user.
     */
    async createUsersResetCommunityEjection(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createUsersResetCommunityEjectionRaw(initOverrides);
    }

    /**
     * The player confirmed a date of birth under 18. Records the date and disables the account immediately with a stored reason. Refuses a date of 18 or over. The response carries the support contact, which is the appeal path.
     */
    async createUsersSelfReportUnderageRaw(requestParameters: CreateUsersSelfReportUnderageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SelfReportUnderageResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/self-report-underage`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SelfReportUnderageBodyToJSON(requestParameters['selfReportUnderageBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SelfReportUnderageResponseFromJSON(jsonValue));
    }

    /**
     * The player confirmed a date of birth under 18. Records the date and disables the account immediately with a stored reason. Refuses a date of 18 or over. The response carries the support contact, which is the appeal path.
     */
    async createUsersSelfReportUnderage(requestParameters: CreateUsersSelfReportUnderageRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SelfReportUnderageResponse> {
        const response = await this.createUsersSelfReportUnderageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Unbans a user from a community.
     */
    async createUsersUnbanUserFromCommunityRaw(requestParameters: CreateUsersUnbanUserFromCommunityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/unban-user-from-community`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BanUserFromCommunityBodyToJSON(requestParameters['banUserFromCommunityBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Unbans a user from a community.
     */
    async createUsersUnbanUserFromCommunity(requestParameters: CreateUsersUnbanUserFromCommunityRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createUsersUnbanUserFromCommunityRaw(requestParameters, initOverrides);
    }

    /**
     * removes a wallet from the given account.
     */
    async deleteUserRemoveWalletRaw(requestParameters: DeleteUserRemoveWalletRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user/remove-wallet`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: RemoveWalletRequestBodyToJSON(requestParameters['removeWalletRequestBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * removes a wallet from the given account.
     */
    async deleteUserRemoveWallet(requestParameters: DeleteUserRemoveWalletRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteUserRemoveWalletRaw(requestParameters, initOverrides);
    }

    /**
     * Admin-initiated account deletion. Runs the same soft-delete + PII scrub cascade as user self-delete; the user document is retained (tombstoned) for churn data.
     */
    async deleteUsersIdRaw(requestParameters: DeleteUsersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteUsersId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Admin-initiated account deletion. Runs the same soft-delete + PII scrub cascade as user self-delete; the user document is retained (tombstoned) for churn data.
     */
    async deleteUsersId(requestParameters: DeleteUsersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteUsersIdRaw(requestParameters, initOverrides);
    }

    /**
     * get user\'s current level lootbox mint record
     */
    async getUserLootboxMintRecordRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NftMintTransaction>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user-lootbox-mint-record`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NftMintTransactionFromJSON(jsonValue));
    }

    /**
     * get user\'s current level lootbox mint record
     */
    async getUserLootboxMintRecord(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NftMintTransaction> {
        const response = await this.getUserLootboxMintRecordRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getUsersRaw(requestParameters: GetUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUsersResponse>> {
        const queryParameters: any = {};

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['includeDeleted'] != null) {
            queryParameters['includeDeleted'] = requestParameters['includeDeleted'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUsersResponseFromJSON(jsonValue));
    }

    /**
     */
    async getUsers(requestParameters: GetUsersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUsersResponse> {
        const response = await this.getUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get user authentication hash for Atlas chat session.
     */
    async getUsersAtlasHashRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AtlasHashResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/atlas-hash`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AtlasHashResponseFromJSON(jsonValue));
    }

    /**
     * Get user authentication hash for Atlas chat session.
     */
    async getUsersAtlasHash(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AtlasHashResponse> {
        const response = await this.getUsersAtlasHashRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getUsersEmailExistsRaw(requestParameters: GetUsersEmailExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetExistingUserResponse>> {
        if (requestParameters['email'] == null) {
            throw new runtime.RequiredError(
                'email',
                'Required parameter "email" was null or undefined when calling getUsersEmailExists().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/users/{email}/exists`;
        urlPath = urlPath.replace(`{${"email"}}`, encodeURIComponent(String(requestParameters['email'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetExistingUserResponseFromJSON(jsonValue));
    }

    /**
     */
    async getUsersEmailExists(requestParameters: GetUsersEmailExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetExistingUserResponse> {
        const response = await this.getUsersEmailExistsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all communities a user is banned from
     */
    async getUsersGetBannedCommunitiesIdRaw(requestParameters: GetUsersGetBannedCommunitiesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBannedCommunitiesResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getUsersGetBannedCommunitiesId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/get-banned-communities/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBannedCommunitiesResponseFromJSON(jsonValue));
    }

    /**
     * Get all communities a user is banned from
     */
    async getUsersGetBannedCommunitiesId(requestParameters: GetUsersGetBannedCommunitiesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBannedCommunitiesResponse> {
        const response = await this.getUsersGetBannedCommunitiesIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getUsersIdRaw(requestParameters: GetUsersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUserResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getUsersId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUserResponseFromJSON(jsonValue));
    }

    /**
     */
    async getUsersId(requestParameters: GetUsersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUserResponse> {
        const response = await this.getUsersIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get information regarding the user\'s community, their rank and points earned for the community.
     */
    async getUsersIdMembershipRaw(requestParameters: GetUsersIdMembershipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUserCommunityMembershipResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getUsersIdMembership().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/{id}/membership`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUserCommunityMembershipResponseFromJSON(jsonValue));
    }

    /**
     * Get information regarding the user\'s community, their rank and points earned for the community.
     */
    async getUsersIdMembership(requestParameters: GetUsersIdMembershipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUserCommunityMembershipResponse> {
        const response = await this.getUsersIdMembershipRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getUsersIdSessionsRaw(requestParameters: GetUsersIdSessionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUserSessionsResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getUsersIdSessions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tokenId'] != null) {
            queryParameters['tokenId'] = requestParameters['tokenId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/{id}/sessions`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUserSessionsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getUsersIdSessions(requestParameters: GetUsersIdSessionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUserSessionsResponse> {
        const response = await this.getUsersIdSessionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the leaderboard nickname of the current user.
     */
    async getUsersLeaderboardNicknameRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLeaderboardNicknameResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/leaderboard-nickname`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLeaderboardNicknameResponseFromJSON(jsonValue));
    }

    /**
     * Get the leaderboard nickname of the current user.
     */
    async getUsersLeaderboardNickname(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLeaderboardNicknameResponse> {
        const response = await this.getUsersLeaderboardNicknameRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get the leaderboard rank of the current user.
     */
    async getUsersLeaderboardRankRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserLeaderboardRankResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/leaderboard-rank`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserLeaderboardRankResponseFromJSON(jsonValue));
    }

    /**
     * Get the leaderboard rank of the current user.
     */
    async getUsersLeaderboardRank(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserLeaderboardRankResponse> {
        const response = await this.getUsersLeaderboardRankRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get information regarding the user\'s level and experience.
     */
    async getUsersLevelIdRaw(requestParameters: GetUsersLevelIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccountLevel>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getUsersLevelId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/level/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccountLevelFromJSON(jsonValue));
    }

    /**
     * Get information regarding the user\'s level and experience.
     */
    async getUsersLevelId(requestParameters: GetUsersLevelIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccountLevel> {
        const response = await this.getUsersLevelIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get lootbox redemption history for a user
     */
    async getUsersLootboxRedemptionsIdRaw(requestParameters: GetUsersLootboxRedemptionsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLootboxRedemptionsResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getUsersLootboxRedemptionsId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/lootbox-redemptions/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLootboxRedemptionsResponseFromJSON(jsonValue));
    }

    /**
     * Get lootbox redemption history for a user
     */
    async getUsersLootboxRedemptionsId(requestParameters: GetUsersLootboxRedemptionsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLootboxRedemptionsResponse> {
        const response = await this.getUsersLootboxRedemptionsIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the SemVer version of the user\'s DevourPlay Electron client, captured server-side from the User-Agent header. Reads the durable `lastElectronVersion` stamped on the account at desktop login, falling back to the 60-minute Redis presence key when the account predates that stamp. Returns null for an account that has never signed in from the desktop app. Path is `/users/me/...` rather than `/users/electron-client-version` to avoid Express matching it against the wildcard `GET /users/:id` route in get_user.ts (which would CastError on the literal string).
     * Get the version of the user\'s currently-running Electron client
     */
    async getUsersMeElectronClientVersionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ElectronClientVersionResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/me/electron-client-version`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ElectronClientVersionResponseFromJSON(jsonValue));
    }

    /**
     * Returns the SemVer version of the user\'s DevourPlay Electron client, captured server-side from the User-Agent header. Reads the durable `lastElectronVersion` stamped on the account at desktop login, falling back to the 60-minute Redis presence key when the account predates that stamp. Returns null for an account that has never signed in from the desktop app. Path is `/users/me/...` rather than `/users/electron-client-version` to avoid Express matching it against the wildcard `GET /users/:id` route in get_user.ts (which would CastError on the literal string).
     * Get the version of the user\'s currently-running Electron client
     */
    async getUsersMeElectronClientVersion(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ElectronClientVersionResponse> {
        const response = await this.getUsersMeElectronClientVersionRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getUsersNftOwnershipsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NftOwnershipInformation>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/users/nft-ownerships`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NftOwnershipInformationFromJSON(jsonValue));
    }

    /**
     */
    async getUsersNftOwnerships(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NftOwnershipInformation> {
        const response = await this.getUsersNftOwnershipsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getUsersProfileRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUserResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/profile`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUserResponseFromJSON(jsonValue));
    }

    /**
     */
    async getUsersProfile(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUserResponse> {
        const response = await this.getUsersProfileRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get top users ranked by total experience, with pagination.
     */
    async getUsersTopLeaderboardRanksRaw(requestParameters: GetUsersTopLeaderboardRanksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TopLeaderboardRanksResponse>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/users/top-leaderboard-ranks`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TopLeaderboardRanksResponseFromJSON(jsonValue));
    }

    /**
     * Get top users ranked by total experience, with pagination.
     */
    async getUsersTopLeaderboardRanks(requestParameters: GetUsersTopLeaderboardRanksRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TopLeaderboardRanksResponse> {
        const response = await this.getUsersTopLeaderboardRanksRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Is this username free to register? Auth optional, so the signup form can ask before an account exists; signed in, a name held by the caller\'s own Drop counts as available.
     */
    async getUsersUsernameAvailabilityRaw(requestParameters: GetUsersUsernameAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UsernameAvailabilityResponse>> {
        if (requestParameters['name'] == null) {
            throw new runtime.RequiredError(
                'name',
                'Required parameter "name" was null or undefined when calling getUsersUsernameAvailability().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Optional", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/username-availability`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UsernameAvailabilityResponseFromJSON(jsonValue));
    }

    /**
     * Is this username free to register? Auth optional, so the signup form can ask before an account exists; signed in, a name held by the caller\'s own Drop counts as available.
     */
    async getUsersUsernameAvailability(requestParameters: GetUsersUsernameAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UsernameAvailabilityResponse> {
        const response = await this.getUsersUsernameAvailabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getUsersUserslvlRaw(requestParameters: GetUsersUserslvlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUsersCsvResponse>> {
        const queryParameters: any = {};

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/userslvl`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUsersCsvResponseFromJSON(jsonValue));
    }

    /**
     */
    async getUsersUserslvl(requestParameters: GetUsersUserslvlRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUsersCsvResponse> {
        const response = await this.getUsersUserslvlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used by users to change their passwords.
     */
    async updateUsersChangePasswordRaw(requestParameters: UpdateUsersChangePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/change-password`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ChangePasswordBodyToJSON(requestParameters['changePasswordBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by users to change their passwords.
     */
    async updateUsersChangePassword(requestParameters: UpdateUsersChangePasswordRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUsersChangePasswordRaw(requestParameters, initOverrides);
    }

    /**
     * Used by users to add or remove a business from their favorites list.
     */
    async updateUsersFavoriteBusinessRaw(requestParameters: UpdateUsersFavoriteBusinessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['businessId'] != null) {
            queryParameters['businessId'] = requestParameters['businessId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/favorite-business`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by users to add or remove a business from their favorites list.
     */
    async updateUsersFavoriteBusiness(requestParameters: UpdateUsersFavoriteBusinessRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUsersFavoriteBusinessRaw(requestParameters, initOverrides);
    }

    /**
     * Used by GOD admins to change user\'s passwords.
     */
    async updateUsersIdChangePasswordRaw(requestParameters: UpdateUsersIdChangePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateUsersIdChangePassword().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("GodAdmin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/{id}/change-password`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ChangeUserPasswordBodyToJSON(requestParameters['changeUserPasswordBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by GOD admins to change user\'s passwords.
     */
    async updateUsersIdChangePassword(requestParameters: UpdateUsersIdChangePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUsersIdChangePasswordRaw(requestParameters, initOverrides);
    }

    /**
     * Used by admins to disable a user
     */
    async updateUsersIdDisableRaw(requestParameters: UpdateUsersIdDisableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateUsersIdDisable().'
            );
        }

        if (requestParameters['accountStatusReasonBody'] == null) {
            throw new runtime.RequiredError(
                'accountStatusReasonBody',
                'Required parameter "accountStatusReasonBody" was null or undefined when calling updateUsersIdDisable().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/{id}/disable`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AccountStatusReasonBodyToJSON(requestParameters['accountStatusReasonBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by admins to disable a user
     */
    async updateUsersIdDisable(requestParameters: UpdateUsersIdDisableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUsersIdDisableRaw(requestParameters, initOverrides);
    }

    /**
     * Used by GOD admins to enable a user
     */
    async updateUsersIdEnableRaw(requestParameters: UpdateUsersIdEnableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateUsersIdEnable().'
            );
        }

        if (requestParameters['accountStatusReasonBody'] == null) {
            throw new runtime.RequiredError(
                'accountStatusReasonBody',
                'Required parameter "accountStatusReasonBody" was null or undefined when calling updateUsersIdEnable().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/{id}/enable`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AccountStatusReasonBodyToJSON(requestParameters['accountStatusReasonBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by GOD admins to enable a user
     */
    async updateUsersIdEnable(requestParameters: UpdateUsersIdEnableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUsersIdEnableRaw(requestParameters, initOverrides);
    }

    /**
     * Toggle marketing blacklist status for a user (admin only)
     */
    async updateUsersIdMarketingBlacklistRaw(requestParameters: UpdateUsersIdMarketingBlacklistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ToggleMarketingBlacklistResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateUsersIdMarketingBlacklist().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/{id}/marketing-blacklist`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ToggleMarketingBlacklistResponseFromJSON(jsonValue));
    }

    /**
     * Toggle marketing blacklist status for a user (admin only)
     */
    async updateUsersIdMarketingBlacklist(requestParameters: UpdateUsersIdMarketingBlacklistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ToggleMarketingBlacklistResponse> {
        const response = await this.updateUsersIdMarketingBlacklistRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Removes a user from their current community
     */
    async updateUsersIdRemoveUserFromCommunityRaw(requestParameters: UpdateUsersIdRemoveUserFromCommunityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateUsersIdRemoveUserFromCommunity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/{id}/remove-user-from-community`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Removes a user from their current community
     */
    async updateUsersIdRemoveUserFromCommunity(requestParameters: UpdateUsersIdRemoveUserFromCommunityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUsersIdRemoveUserFromCommunityRaw(requestParameters, initOverrides);
    }

    /**
     * Used by admins to change a user\'s type.
     */
    async updateUsersIdTypeRaw(requestParameters: UpdateUsersIdTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateUsersIdType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Discriminated", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/{id}/type`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserTypeBodyToJSON(requestParameters['updateUserTypeBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by admins to change a user\'s type.
     */
    async updateUsersIdType(requestParameters: UpdateUsersIdTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUsersIdTypeRaw(requestParameters, initOverrides);
    }

    /**
     * Set the per-account clip recording toggle
     */
    async updateUsersPreferencesClipsRecordingRaw(requestParameters: UpdateUsersPreferencesClipsRecordingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updateClipsRecordingPreferenceBody'] == null) {
            throw new runtime.RequiredError(
                'updateClipsRecordingPreferenceBody',
                'Required parameter "updateClipsRecordingPreferenceBody" was null or undefined when calling updateUsersPreferencesClipsRecording().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/preferences/clips-recording`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateClipsRecordingPreferenceBodyToJSON(requestParameters['updateClipsRecordingPreferenceBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Set the per-account clip recording toggle
     */
    async updateUsersPreferencesClipsRecording(requestParameters: UpdateUsersPreferencesClipsRecordingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUsersPreferencesClipsRecordingRaw(requestParameters, initOverrides);
    }

    /**
     * Persist the signed-in user\'s cookie-consent decision to their account
     */
    async updateUsersPreferencesCookieConsentRaw(requestParameters: UpdateUsersPreferencesCookieConsentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updateCookieConsentBody'] == null) {
            throw new runtime.RequiredError(
                'updateCookieConsentBody',
                'Required parameter "updateCookieConsentBody" was null or undefined when calling updateUsersPreferencesCookieConsent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/preferences/cookie-consent`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCookieConsentBodyToJSON(requestParameters['updateCookieConsentBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Persist the signed-in user\'s cookie-consent decision to their account
     */
    async updateUsersPreferencesCookieConsent(requestParameters: UpdateUsersPreferencesCookieConsentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUsersPreferencesCookieConsentRaw(requestParameters, initOverrides);
    }

    /**
     * Used by users to remove their profile picture.
     */
    async updateUsersRemoveProfilePictureRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/remove-profile-picture`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by users to remove their profile picture.
     */
    async updateUsersRemoveProfilePicture(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUsersRemoveProfilePictureRaw(initOverrides);
    }

    /**
     * Used by users to add, remove or update their default payment method.
     */
    async updateUsersUpdateDefaultPaymentRaw(requestParameters: UpdateUsersUpdateDefaultPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['defaultPaymentMethodId'] != null) {
            queryParameters['defaultPaymentMethodId'] = requestParameters['defaultPaymentMethodId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/update-default-payment`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by users to add, remove or update their default payment method.
     */
    async updateUsersUpdateDefaultPayment(requestParameters: UpdateUsersUpdateDefaultPaymentRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUsersUpdateDefaultPaymentRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateUsersUpdateNftOwnershipsForUserRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/update-nft-ownerships-for-user`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateUsersUpdateNftOwnershipsForUser(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUsersUpdateNftOwnershipsForUserRaw(initOverrides);
    }

    /**
     * Used by users to update their profile.
     */
    async updateUsersUpdateNotificationsRaw(requestParameters: UpdateUsersUpdateNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/update-notifications`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateNotificationsBodyToJSON(requestParameters['updateNotificationsBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by users to update their profile.
     */
    async updateUsersUpdateNotifications(requestParameters: UpdateUsersUpdateNotificationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUsersUpdateNotificationsRaw(requestParameters, initOverrides);
    }

    /**
     * Used by users to update their profile.
     */
    async updateUsersUpdateProfileRaw(requestParameters: UpdateUsersUpdateProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/update-profile`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateProfileBodyToJSON(requestParameters['updateProfileBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by users to update their profile.
     */
    async updateUsersUpdateProfile(requestParameters: UpdateUsersUpdateProfileRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUsersUpdateProfileRaw(requestParameters, initOverrides);
    }

    /**
     * Used by users to update their profile picture.
     */
    async updateUsersUpdateProfilePictureRaw(requestParameters: UpdateUsersUpdateProfilePictureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/update-profile-picture`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateProfilePictureBodyToJSON(requestParameters['updateProfilePictureBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by users to update their profile picture.
     */
    async updateUsersUpdateProfilePicture(requestParameters: UpdateUsersUpdateProfilePictureRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUsersUpdateProfilePictureRaw(requestParameters, initOverrides);
    }

}
